import { useState } from 'react';

import { Modal, StaticModal, useModal } from '@/modules/modals';

import { ApiKeyNameStep } from './ApiKeyNameStep';
import { ApiKeyRevealStep } from './ApiKeyRevealStep';

export const CreateApiKeyModal = () => {
    const { modal, updateModal } = useModal(StaticModal.CREATE_API_KEY, { autoClose: true });

    const [fullKey, setFullKey] = useState<string | null>(null);

    const handleClose = () => {
        updateModal(false);
        setFullKey(null);
    };

    return (
        <Modal open={modal?.visibility} closable onClose={handleClose} width={520}>
            {fullKey === null ? <ApiKeyNameStep onCreated={setFullKey} /> : <ApiKeyRevealStep apiKey={fullKey} onDone={handleClose} />}
        </Modal>
    );
};
